export default __webpack_public_path__ + "static/media/clap.cd5d1346.mp3";